import { render, staticRenderFns } from "./CategoriesAccountig.vue?vue&type=template&id=764f71c6"
import script from "./CategoriesAccountig.vue?vue&type=script&lang=js"
export * from "./CategoriesAccountig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports